import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { openOwnerClubPortal } from "../../../utils/ownerClubPortal";
import { trackPaymentSuccess } from "../../../analytics/metrikaGoals";
import OwnerClubSubscriptionCard from "../../common/ClubSubscription/OwnerClubSubscriptionCard";
import { useOwnerDashboard } from "./OwnerDashboardContext";
import OwnerClubPayModal from "./OwnerClubPayModal";
import { OwnerCabinetHubLink } from "./OwnerCabinetHubLink";
import { OwnerPage, OwnerState } from "./OwnerPage";
import s from "./ownerCabinet.module.css";

export default function OwnerBilling() {
  const { clubs, loading, error, reload } = useOwnerDashboard();
  const [searchParams, setSearchParams] = useSearchParams();
  const [payClub, setPayClub] = useState(null);
  const [openingClubId, setOpeningClubId] = useState(null);

  useEffect(() => {
    if (searchParams.get("payment") !== "success") return;
    trackPaymentSuccess({ source: "owner_billing" });
    searchParams.delete("payment");
    setSearchParams(searchParams, { replace: true });
    reload?.();
  }, [searchParams, setSearchParams, reload]);

  const openClubAdmin = async (club) => {
    if (openingClubId) return;
    setOpeningClubId(club.id);
    try {
      await openOwnerClubPortal(club);
    } finally {
      setOpeningClubId(null);
    }
  };

  if (loading) return <OwnerState variant="loading">Загрузка…</OwnerState>;
  if (error) return <OwnerState variant="error">{error}</OwnerState>;

  if (!clubs.length) {
    return (
      <OwnerPage title="Тариф и оплата" subtitle="Статус подписок по клубам">
        <OwnerState variant="muted">
          Нет клубов.{" "}
          <Link to="/register-clinic" className={s.linkAccent}>
            Зарегистрировать секцию
          </Link>
        </OwnerState>
      </OwnerPage>
    );
  }

  return (
    <OwnerPage
      title="Тариф и оплата"
      subtitle="Оплата и смена тарифа"
    >
      <div className={s.ownerHubPanel}>
        <OwnerCabinetHubLink billingActive />
      </div>

      <div className={s.cardGrid}>
        {clubs.map((club) => (
          <div key={club.id} className={s.billingClubCard}>
            <OwnerClubSubscriptionCard
              club={club}
              onOpenAdmin={openClubAdmin}
              onPay={setPayClub}
            />
          </div>
        ))}
      </div>

      <OwnerClubPayModal
        club={payClub}
        open={Boolean(payClub)}
        onClose={() => setPayClub(null)}
      />
    </OwnerPage>
  );
}
